module.exports = __webpack_public_path__ + "img/fut.dc8f689c.jpg";